import { useCallback } from 'react';

import {
  type BoardsListOptions,
  type ClipAndBoardListItem,
  type ListResponse,
  type SortDirection,
  type ViewField,
} from '@air/api/types';

import { usePrivateBoardsFetcher } from '~/swr-hooks/gallery/galleryView/usePrivateBoardsFetcher';

export const usePrivateTableViewBoardsDataFetcher = () => {
  const { privateBoardsFetcher } = usePrivateBoardsFetcher();

  const privateTableViewBoardsDataFetcher = useCallback(
    async ({
      params,
      sortFieldName,
      sortDirection,
      cursor,
    }: {
      cursor: string | null;
      params: Partial<BoardsListOptions>;
      sortFieldName: ViewField['name'];
      sortDirection: SortDirection;
    }): Promise<ListResponse<ClipAndBoardListItem>> => {
      const { data, pagination, total } = await privateBoardsFetcher({ params, sortFieldName, sortDirection, cursor });
      return {
        data: data.map((board) => ({
          id: board.id,
          type: 'board',
          data: board,
        })),
        total,
        pagination,
      };
    },
    [privateBoardsFetcher],
  );

  return {
    privateTableViewBoardsDataFetcher,
  };
};
